import { NOT_FOUND_INDEX } from "../../constants/numeric";
import { ChatActions, ChatMessage, ChatSetState, ChatState } from "../chatTypes";

const THINKING_TYPE = "thinking";

type StreamingActions = Pick<ChatActions, "handleStreamUpdate" | "handleThinkingDelta" | "handleComplete">;

const findStreamingAssistantIndex = (messages: ChatMessage[]): number =>
  messages.findIndex((msg: ChatMessage) => msg.role === "assistant" && msg.isStreaming);

const updateMessageAtIndex = (
  messages: ChatMessage[],
  targetIndex: number,
  updater: (msg: ChatMessage) => ChatMessage
): ChatMessage[] =>
  messages.map((msg: ChatMessage, idx: number) =>
    idx === targetIndex ? updater(msg) : msg
  );

export const createStreamingActions = (set: ChatSetState): StreamingActions => ({
  handleStreamUpdate: (content: string): void => {
    set((state: ChatState) => {
      const messageIndex = findStreamingAssistantIndex(state.messages);

      if (messageIndex === NOT_FOUND_INDEX) {
        return {};
      }

      return {
        messages: updateMessageAtIndex(state.messages, messageIndex, (msg) => ({
          ...msg,
          content: msg.content + content,
          isThinking: false
        }))
      };
    });
  },

  handleThinkingDelta: (delta: string, type: string): void => {
    if (type !== THINKING_TYPE) {
      return;
    }

    set((state: ChatState) => {
      const messageIndex = findStreamingAssistantIndex(state.messages);

      if (messageIndex === NOT_FOUND_INDEX) {
        return {};
      }

      return {
        messages: updateMessageAtIndex(state.messages, messageIndex, (msg) => ({
          ...msg,
          thinkingContent: (msg.thinkingContent ?? "") + delta
        }))
      };
    });
  },

  handleComplete: (): void => {
    set((state: ChatState) => {
      const messageIndex = findStreamingAssistantIndex(state.messages);

      if (messageIndex === NOT_FOUND_INDEX) {
        return {};
      }

      return {
        messages: updateMessageAtIndex(state.messages, messageIndex, (msg) => ({
          ...msg,
          isStreaming: false
        }))
      };
    });
  }
});
